const { Component } = require("react");



class Blog extends Component{
    
    render(){
        return(
            <>
                <h1>Welcome to Blog Component</h1>
            </>
        )
    }
}

export default Blog